export function TextInput({
  ...props
}: React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <div className="w-full">
      <input
        {...props}
        className={`!outline-none w-full bg-ultraLightGray focus:bg-white rounded-lg border border-lightGray focus:border-grey2 p-[18px] text-base text-black ${
          props.className || ""
        }`}
      />
    </div>
  );
}
